import moment from 'moment';
import { PacienteInfo } from '../types/types.patient';
import { FilteredOrders } from '../types/types.orders';

export function convertData(input) {
  const OrderData = {
    ...input.Orden,
    AditionalFields: {},
  };

  delete OrderData.Dyn;

  for (const dynField of input.Dyn) {
    OrderData.AditionalFields[dynField.Equivalencia] = dynField.Valor;
  }

  const StudiesData: any = [];

  for (const study of input.Estudios) {
    const StudyData: any = {
      ...study.Data,
      AditionalFields: {},
    };

    for (const dynField of study.Dyn) {
      StudyData['AditionalFields'][dynField.Equivalencia] = dynField.Valor;
    }

    StudiesData.push(StudyData);
  }
  const idTransaction = input.IdTransaction ? input.IdTransaction : null;

  return {
    OrderData,
    IdOrder: input.Orden.Ord_Id,
    IdTran: idTransaction,
    StudiesData,
  };
}

export const generateFiltersText = (filters: FilteredOrders, LstAreas, LstEstudios, LstServicios, LIS_States, LstSedes): string[] => {
  const filtersText: string[] = [];
  const today = new Date();
  const todayConverted = ConvertLocalDate(today);

  // Fechas (solo si no son del día actual)
  if (filters.Fechas && filters.Fechas.length === 2) {
    const fechaInicio = filters.Fechas[0];
    const fechaFin = filters.Fechas[1];

    // Convertir las fechas usando la misma función que se usa en el sistema
    const fechaInicioConverted = typeof fechaInicio === 'string' ? fechaInicio : ConvertLocalDate(fechaInicio);
    const fechaFinConverted = typeof fechaFin === 'string' ? fechaFin : ConvertLocalDate(fechaFin);

    // Comparar solo las fechas (sin horas) usando la función del sistema
    const fechaInicioDate = fechaInicioConverted.split('T')[0];
    const fechaFinDate = fechaFinConverted.split('T')[0];
    const todayDate = todayConverted.split('T')[0];

    // Solo agregar si no son fechas del día actual y las fechas no son null
    if (fechaInicio != null && fechaFin != null && (fechaInicioDate !== todayDate || fechaFinDate !== todayDate)) {
      const fechaInicioFormat = new Date(fechaInicio).toLocaleDateString();
      const fechaFinFormat = new Date(fechaFin).toLocaleDateString();
      filtersText.push(`Fechas: ${fechaInicioFormat} - ${fechaFinFormat}`);
    }
  }

  // Orden (rango desde - hasta)
  if (filters.Orden && filters.Orden.length > 0) {
    const ordenDesde = filters.Orden[0];
    const ordenHasta = filters.Orden[1];
    if (ordenDesde || ordenHasta) {
      filtersText.push(!ordenHasta || ordenDesde === ordenHasta ? `Orden: ${ordenDesde || ordenHasta}` : `Orden: ${ordenDesde} - ${ordenHasta}`);
    }
  }

  // Paciente
  if (filters.Paciente) {
    filtersText.push(`Paciente: ${filters.Paciente}`);
  }

  // Áreas
  if (filters.Areas && filters.Areas.length > 0) {
    const areasNames = filters.Areas.map((areaId) => LstAreas?.find((area) => area.Aa_Id === areaId)?.Aa_Nombre || `ID: ${areaId}`).join(', ');
    filtersText.push(`Áreas: ${areasNames}`);
  }

  // Estudios
  if (filters.Estudios && filters.Estudios.length > 0) {
    const estudiosNames = filters.Estudios.map((estudioId) => LstEstudios?.find((estudio) => estudio.Es_Id === estudioId)?.Es_Nombre || `ID: ${estudioId}`).join(', ');
    filtersText.push(`Estudios: ${estudiosNames}`);
  }

  // Servicios
  if (filters.Servicios && filters.Servicios.length > 0) {
    const serviciosNames = filters.Servicios.map((servicioId) => LstServicios?.find((servicio) => servicio.Se_Id === servicioId)?.Se_Nombre || `ID: ${servicioId}`).join(', ');
    filtersText.push(`Servicios: ${serviciosNames}`);
  }

  // Estados
  if (filters.Estados && filters.Estados.length > 0) {
    const estadosNames = filters.Estados.map((estadoId) => LIS_States.find((estado) => estado.Value === estadoId)?.State || `ID: ${estadoId}`).join(', ');
    filtersText.push(`Estados: ${estadosNames}`);
  }

  // Sedes
  if (filters.Sedes && filters.Sedes.length > 0) {
    const sedesNames = filters.Sedes.map((sedeId) => LstSedes?.find((sede) => sede.Sd_Id === sedeId)?.Sd_Nombre || `ID: ${sedeId}`).join(', ');
    filtersText.push(`Sedes: ${sedesNames}`);
  }
  
  //Tracking
  if (filters.Tracking !== undefined && filters.Tracking !== null) {
    filtersText.push(`Tracking: ${filters.Tracking ? 'Sí' : 'No'}`);
  }

  //Remitido
  if (filters.Remitido !== undefined && filters.Remitido !== null) {
    filtersText.push(`Remitido: ${filters.Remitido ? 'Sí' : 'No'}`);
  }

  // Campos dinámicos
  if (filters.CamposDinamicos && filters.CamposDinamicos.length > 0) {
    filters.CamposDinamicos.forEach((campo) => {
      // Usar DisplayValues si está disponible, sino usar Values
      const valuesText = campo.DisplayValues 
        ? campo.DisplayValues.join(', ') 
        : campo.Values.map((v) => String(v)).join(', ');
      filtersText.push(`${campo.Label}: ${valuesText}`);
    });
  }

  return filtersText;
};

export const ConvertDataPatient = (e) => {
  const Patient: PacienteInfo[] = e as PacienteInfo[];
  const convertedObject = {
    ...Patient[0].Paciente,
    AditionalFields: {},
  };
  Patient.forEach((item) => {
    convertedObject.AditionalFields[item.Dyn[0].Equivalencia] = item.Dyn[0].Valor;
  });
  return convertedObject;
};

export const ConvertDataOrder = (e) => {
  const Orden = e;
  const convertedObject = {
    ...Orden.Orden,
    AditionalFields: {},
  };
  Orden.Dyn.forEach((item) => {
    convertedObject.AditionalFields[item.Equivalencia] = item.Valor;
  });
  return convertedObject;
};

export const ConvertDataPatientOrders = (e) => {
  const Patient: PacienteInfo = e as PacienteInfo;
  const convertedObject = {
    ...Patient.Paciente,
    AditionalFields: {},
  };
  Patient.Dyn.forEach((item) => {
    convertedObject.AditionalFields[item.Equivalencia] = item.Valor;
  });
  return convertedObject;
};

export function convertImageToBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function ConvertLocalDate(date) {
  // Restar 5 horas para ajustar a la hora de Colombia (UTC-5)
  const localDate = new Date(date);
  localDate.setHours(localDate.getHours() - 5);

  // Convertir la fecha ajustada a formato ISO 8601
  return localDate.toISOString();
}

// El backend guarda la fecha literal que recibe. Serializar un Date con JSON lo pasa a
// UTC (la hora queda +5), así que las fechas con hora se envían como cadena local, sin
// sufijo Z, para que en base de datos quede la misma hora que se ve en pantalla.
export function ConvertLocalDateTime(date: Date | string | null | undefined) {
  if (!date) return undefined;

  const localDate = new Date(date);
  const pad = (value: number) => `${value}`.padStart(2, '0');

  return `${localDate.getFullYear()}-${pad(localDate.getMonth() + 1)}-${pad(localDate.getDate())}T${pad(localDate.getHours())}:${pad(localDate.getMinutes())}:${pad(localDate.getSeconds())}`;
}

// Función para calcular la edad desde una fecha
export const calculateAge = (birthDate: string | Date) => {
  if (!birthDate) return '';

  const now = moment();
  const birth = moment(birthDate);

  if (!birth.isValid()) return '';

  const totalDays = now.diff(birth, 'days');

  // Si es mayor o igual a 360 días (aproximadamente 1 año), mostrar en años
  if (totalDays >= 360) {
    const years = now.diff(birth, 'years');
    return `${years} ${years === 1 ? 'Año' : 'Años'}`;
  }

  // Si es mayor o igual a 30 días pero menor a 360 días, mostrar en meses
  if (totalDays >= 30) {
    const months = now.diff(birth, 'months');
    return `${months} ${months === 1 ? 'Mes' : 'Meses'}`;
  }

  // Si es menor a 30 días, mostrar en días
  return `${totalDays} ${totalDays === 1 ? 'Día' : 'Días'}`;
};
